export default [
	{
		prop: 'id',
		label: '序号',
		// width:120,
	},
	{
		prop: 'wlbm',
		label: '物料编码',
		// width:120,
	},
	{
		prop: 'pc',
		label: '批次号',
		// width:120,
	},
	{
		prop: 'wlms',
		label: '物料描述',
		width: 200,
	},
	// {
	//   prop: 'htsl',
	//   label: '合同数量',
	//   // width:120,
	// },
	{
		prop: 'dddw',
		label: '订单单位',
		// width:120,
		//   isTemplate:true
	},
	{
		prop: 'cgsqh',
		label: '采购申请号',
		// width:120,
	},
	{
		prop: 'cgsqhxm',
		label: '采购申请行项目',
		width: 120,
	},
	{
		prop: 'gysmc',
		label: '备注',
		fixed: 'right',
		isTemplate: true,
		width: 200,
		align: 'center',
	},
	{
		prop: 'storageLocation',
		label: '库位',
		fixed: 'right',
		isTemplate: true,
		width: 160,
		align: 'center'
	},
	// {
	//   prop: 'appSupplierId',
	//   label: '供应商评分数据',
	//   width:120,
	// },
	// {
	//   prop: 'bcxycgdd',
	//   label: '补充协议采购订单',
	//   width:120,

	// },
	// {
	//   prop: 'bcxycgddhxm',
	//   label: '补充协议采购订单行项目',
	//   width:160,
	// },
	// {
	//   prop: 'bcxyh',
	//   label: '补充协议号'
	// },
	// {
	//   prop: 'bcxyhtbhjf',
	//   label: '补充协议合同编号(经法)',
	//   width:160,
	// },
	// {
	//   prop: 'bcxyjhrq',
	//   label: '补充协议交货日期',
	//   width:120,
	// },
	// {
	//   prop: 'bcxytzhzje',
	//   label: '补充协议调整后总金额',
	//   width:140,
	// },
	// {
	//   prop: 'bcxytzhzsl',
	//   label: '补充协议调整后总数量',
	//   width:140,
	// },
	// {
	//   prop: 'bglx',
	//   label: '变更类型'
	// },
	// {
	//   prop: 'bhlx',
	//   label: '保函类型'
	// },
	// {
	//   prop: ' cgdd',
	//   label: '采购订单'
	// },
	// {
	//   prop: 'cgddList',
	//   label: '采购订单号 多采购订单号查询',
	//   width:180,
	// },
	// {
	//   prop: 'cgddjj',
	//   label: '采购订单净价',
	//   width:100,
	// },
	// {
	//   prop: 'cgsqh',
	//   label: '采购申请号'
	// },
	// {
	//   prop: 'cgsqhxm',
	//   label: '采购申请行项目',
	//   width:120,
	// },
	// {
	//   prop: 'cgsqsl',
	//   label: '采购申请数量',
	//   width:120,
	// },
	// {
	//   prop: 'contractList',
	//   label: '合同属性集合，in查询条件',
	//   width:180,
	// },
	// {
	//   prop: 'cpfbm',
	//   label: '出票方编码'
	// },
	// {
	//   prop: 'cpfmc',
	//   label: '出票方名称'
	// },
	// {
	//   prop: 'cqsx',
	//   label: '产权属性'
	// },
	// {
	//   prop: 'dddw',
	//   label: '订单单位'
	// },
	// {
	//   prop: 'ddhxm',
	//   label: '订单行项目'
	// },
	// {
	//   prop: 'dhdjr',
	//   label: '到货登记人'
	// },
	// {
	//   prop: 'dhk',
	//   label: '到货款'
	// },
	// {
	//   prop: 'dj',
	//   label: '单价'
	// },
	// {
	//   prop: 'dldwwb',
	//   label: '度量单位文本',
	//   width:120,
	// },
	// {
	//   prop: 'dtgc',
	//   label: '单体工程'
	// },
	// {
	//   prop: 'dtgcms',
	//   label: '单体工程描述',
	//   width:120,
	// },
	// {
	//   prop: 'dzswhtbh',
	//   label: '电子商务合同编号',
	//   width:120,
	// },
	// {
	//   prop: 'dzswhthxm',
	//   label: '电子商务合同行项目',
	//   width:140,
	// },
	// {
	//   prop: 'dzysbg',
	//   label: '电子验收报告',
	//   width:120,
	// },
	// {
	//   prop: 'dzysbgsprq',
	//   label: '电子验收报告审批日期',
	//   width:160,
	// },
	// {
	//   prop: 'dzysbgspzt',
	//   label: '电子验收报告审批状态',
	//   width:160,
	// },
	// {
	//   prop: 'ejfl',
	//   label: '二级分类'
	// },
	// {
	//   prop: 'ejflms',
	//   label: '二级分类描述',
	//   width:120,
	// },
	{
		prop: 'copies',
		label: '标签数量',
		fixed: 'right',
		isTemplate: true,
		width: 160,
		align: 'center'
	}, {
		prop: 'num',
		label: '物资数量',
		fixed: 'right',
		isTemplate: true,
		width: 160,
		align: 'center'
	},
]
